var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('h3', {
    class: _vm.$style.title
  }, [_vm._v(_vm._s(_vm.category))]), _vm.apps.length ? _c('MottoIcon', {
    staticClass: "mr-4 cursor-pointer",
    attrs: {
      "name": "Grid",
      "icon-color": "lightGray"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.$emit('openGridView');
      }
    }
  }) : _vm._e()], 1), !_vm.apps.length ? _c('p', {
    class: _vm.$style.emptySentence
  }, [_vm._v(_vm._s(_vm.emptySentence))]) : _vm._e(), _vm.apps.length ? _c('carousel', {
    class: _vm.$style.carousel,
    attrs: {
      "per-page-custom": [[0, 4], [1584, 5], [1850, 6], [2120, 7], [2500, 8]],
      "pagination-enabled": false,
      "navigation-enabled": true,
      "navigation-next-label": '',
      "navigation-prev-label": ''
    }
  }, _vm._l(_vm.apps, function (app) {
    return _c('slide', {
      key: app.appId
    }, [_c('AppBlock', {
      class: _vm.$style.appBlock,
      attrs: {
        "name": app.appName,
        "description": app.description,
        "category": app.category,
        "card-image": app.cardImage,
        "card-image-mobile": app.cardImageMobile,
        "app-url": app.appUrl,
        "app-id": app.appId
      }
    })], 1);
  }), 1) : _vm._e(), _vm.apps.length ? _c('div', {
    class: _vm.$style.mobileCarousel
  }, _vm._l(_vm.apps, function (app) {
    return _c('AppBlock', {
      key: app.appId,
      class: _vm.$style.appBlock,
      attrs: {
        "name": app.appName,
        "description": app.description,
        "category": app.category,
        "card-image": app.cardImage,
        "card-image-mobile": app.cardImageMobile,
        "app-url": app.appUrl,
        "app-id": app.appId
      }
    });
  }), 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }